import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { SnotifyService } from 'ng-snotify';
import { UserService } from 'src/app/services/user.service';
import { FilterService } from 'src/app/services/filter.service';
import { Router } from '@angular/router';
import { Constants } from 'src/app/app-constants';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent implements OnInit {

  constants: any = Constants;
  filterItens: any = {
    'channel': '',
    'companies': '',
    'location': '',
    'tp_lead': '',
    'tp_person': ''
  };

  formCadastro: any;

  filterCidades: any = [];
  dataTable: any;
  loading = false;
  arrUsers: any = [];

  public form: any = {
    cadastro: '',
    empresa: '',
    tipo: '',
    estado: '',
    estadoSigla: '',
    cidade: '',
    contato: ''
  };

  public formNotificacao: any = {
    purl: '',
    titulo: '',
    plate: '',
    tp: '',
    msg: '',
    emails: ''
  };
  masterSelected: Boolean;
  active: boolean = false;

  constructor(private notify: SnotifyService, private User: UserService , private Filter: FilterService, private router: Router) { }

  getCities(estadoId) {
    if (estadoId == '') {
      this.filterCidades = [];
    } else {
      this.form.estadoSigla = this.filterItens.location[Number(estadoId)]['uf'];
      this.filterCidades = this.filterItens.location[Number(estadoId)].cities;
    }
  }

  onSubmit() {
    this.active = true;
    this.loading = true;
    if (this.form.contato) {
      this.form.contato = Number(this.form.contato) + 1
    }
    this.getUserListByForm(
      this.form.cadastro, this.form.empresa, this.form.estadoSigla, this.form.cidade, this.form.contato, this.form.tipo
    );
  }

  submitNotificacoes() {
    this.loading = true;
    if (this.formNotificacao.tp == ""){
      alert('Campo "tipo de notificação" é obrigatório');
      this.loading = false;
      return;
    } else if(this.formNotificacao.emails == ""){
      alert('É preciso selecionar ao menos um destinatário');
      this.loading = false;
      return;
    } else if(this.formNotificacao.titulo == ""){
      alert('Campo "título" é obrigatório');
      this.loading = false;
      return;
    }

    this.Filter.sendNotification(this.formNotificacao.emails, this.formNotificacao.purl, this.formNotificacao.titulo, this.formNotificacao.msg, this.formNotificacao.plate, this.formNotificacao.tp).subscribe(
      result => {
        this.loading = false;
        alert('Notificação Enviada');
      },
      error => {
        this.loading = false;
        alert('Notificação Enviada');
      }
    );
  }

  toggleAll() {
    this.arrUsers.forEach(e => {
      e.send = this.masterSelected;
    })
  }

  saveEmails(users) {

    this.formNotificacao.emails = this.arrUsers.filter(e => { 
      return e.send; 
    }).map(e => {
      return e.email;
    }).join(',');

    this.masterSelected = this.arrUsers.every((e) => {
      return e.send;
    });

  }

  getUserListByForm(tpPessoa, company, uf, city, tpContato, role) {
    this.Filter.getUsersLista(tpPessoa, company, uf, city, tpContato, role).subscribe(
      result => {
        this.loading = false;
        this.arrUsers = result;
        this.arrUsers.forEach(user => {
          user.send = true;
        });

        this.saveEmails(this.arrUsers);
      },
      error => {
        this.loading = false;
        this.notify.error('Erro ao retornar os usuários', {timeout: 3000, showProgressBar: false });
      }
    );
  }

  ngOnInit() {
    this.loading = true;
    this.Filter.getFilterParams().subscribe(
      result => {
        this.filterItens = result;
      },
      error => {
        console.log(error);
      }
    );

    this.getUserListByForm('', '', '', '', '', '');

  }

  downloadCSV() {
    this.active = true;
    this.loading = true;
    if (this.form.contato) {
      this.form.contato = Number(this.form.contato) + 1;
    }

    try {
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      a.href = `${this.constants.apiMautic}/filter/search_csv?tpPessoa=${this.form.cadastro}&company=${this.form.empresa}&uf=${this.form.estadoSigla}&city=${this.form.cidade}&tpContato=${this.form.contato}&role=${this.form.tipo}`;
      a.target = '_blank';
      a.click();
      document.body.removeChild(a);
      this.loading = false;

    } catch (error) {
      console.error('Error =>', error);
      this.loading = false;
      this.notify.error('Erro ao retornar os usuários', {timeout: 3000, showProgressBar: false });
    }

    // this.Filter.getUsersListaCSV(this.form.cadastro, this.form.empresa,
    //   this.form.estadoSigla, this.form.cidade, this.form.contato, this.form.tipo).subscribe(
    //   result => {
    //     this.loading = false;
    //   },
    //   error => {
    //     this.loading = false;
    //     this.notify.error('Erro ao retornar os usuários', {timeout: 3000, showProgressBar: false });
    //   }
    // );
  }

  getRole(manager, role) {
    if (manager === '0') {
      return 'Master';
    } else {
      return role;
    }
  }

  addUserAdmin() {
    this.router.navigateByUrl('/signup');
  }

  addUserMaster() {
    this.router.navigateByUrl('/signup-master');
  }

}
